/**
 * "Über diese Daten": one short explanation per master-data class, shown next
 * to the list title, as the catalog tooltip and under the create dialog's title.
 *
 * Interface copy, so it lives here and not in the API: same tone and terms as
 * the rest of the UI, and changing a sentence needs no backend release.
 */
const CLASS_HINTS: Readonly<Record<string, string>> = {
  ProduktType: 'Das verkaufte Produkt, z. B. HBE261A. Kunden kaufen Instanzen davon.',
  ProduktVersion:
    'Eine Stückliste des Produkts: entweder ein offizielles Release des Herstellers oder eine Kundenversion – die Konfiguration, die genau eine Produktinstanz tatsächlich fährt. Kundenversionen entstehen beim Upload eines Scans auf die Produktinstanz.',
  KomponenteVersion:
    'Eine Komponente auf einem bestimmten Firmware- oder Software-Stand. Über ihre Kennungen findet Dependency-Track die passenden CVEs.',
  ProduktVersionKomponente: 'Welche Komponentenversionen eine Produktversion enthält.',
  ProduktInstanz:
    'Ein ausgeliefertes Gerät bei einem Kunden. Die ausgelieferte Version bleibt fest; die aktuelle Version folgt den Hersteller-Updates oder ist eine eigene Kundenversion, wenn der Kunde selbst Komponenten getauscht hat.',
  CVE: 'Manuell erfasste, importierte oder aus KEV-Treffern übernommene CVEs. Alle Scan-Befunde unter „Schwachstellen“.',
  VulnerabilityEvent:
    'Die Bewertung, ob eine CVE auf eine Komponentenversion zutrifft. Der KEV-Scan legt sie an, bewertet wird sie unter „Triage“.',
  Benachrichtigung:
    'Die Benachrichtigung eines Kunden samt CRA-Meldefristen. Sie entsteht, wenn eine Bewertung auf „Betroffen“ gesetzt wird.',
  PsirtTeam:
    'Das Product Security Incident Response Team: Meldestelle für Schwachstellen, CVD-Policy und Meldeweg an CSIRT und ENISA (CRA Art. 13 und 14). Gepflegt wird es unter „Verantwortlichkeit“.',
  ProduktVerantwortung:
    'Wer für ein Produkt nach dem CRA einsteht: PSIRT-Team, Product Security Owner, Supportzeitraum und Produktkategorie. Genau eine je Produkt.',
};

/** The explanation for a class, or null when there is none. */
export function classHint(klass: string | undefined): string | null {
  return (klass && CLASS_HINTS[klass]) || null;
}
